import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { Question } from '../../../types/questionnaire';

interface BaseQuestionRendererProps {
  question: Question;
  children: React.ReactNode;
}

export const BaseQuestionRenderer: React.FC<BaseQuestionRendererProps> = ({ question, children }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" component="label" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {question.caption}
        {question.isRequired && (
          <Typography component="span" color="error" sx={{ ml: 0.5 }}>
            *
          </Typography>
        )}
        {question.tooltip && (
          <Tooltip title={question.tooltip} arrow>
            <IconButton size="small" sx={{ ml: 1 }}>
              <HelpOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Typography>
      {children}
      {question.note && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {question.note}
        </Typography>
      )}
    </Box>
  );
};
